import { OverlayTrigger, Tooltip } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../Capacity/capacity.css";
import moment from "moment/moment";
import { getGeneratorPlantDetails } from "../../store/Capacity/actions";
import { useDispatch, useSelector } from "react-redux";
import "../DashBoard/previewModel.css";
import { toast } from "react-toastify";
import { toastProperties } from "../../commons/Toast/Toaster";
import dayjs from "dayjs";
import { addHours } from "date-fns";
import biddingGeneratorService from "../../components/Services/biddingGenerator.service";
import biddingConsumerService from "../../components/Services/biddingConsumer.service";
import { getConsumerDetails } from "../../store/ConsumerCapacity/action";
import CustomTimePicker from "../../components/TimePicker/customTimePicker";
import { disableButton, enableButton } from "../../store/ButtonFlag/actions";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

export const ChildCapacity = ({
  getMatchingProfiles,
  getMatchingProfilesCon,
  bidsListing,
  bidItem,
  selectedCardData,
  closeChildCapacityModal,
  closeAddsBidsModal,
  handlePlaceBidText,
  bitType,
}) => {
  const dispatch = useDispatch();
  const generatorPlantDetails = useSelector(
    (state) => state?.capacityReducer?.plantData || []
  );
  const role = useSelector((state) => state?.sessionState?.role);
  const configKey = useSelector((state) => state?.sessionState?.connectionName);
  const isButtonEnabled = useSelector(
    (state) => state?.buttonReducer?.isButtonEnabled
  );

  const [fixedValue, setFixedValue] = useState(
    bidsListing?.childCapacity?.energyRateStr ? false : true
  );

  const consumerDetails = useSelector(
    (state) => state?.consumerCapacityReducer?.consumerDetails || []
  );
  const initialValues = {
    startDate:
      bidsListing?.childCapacity?.dateStartAt &&
      new Date(bidsListing?.childCapacity?.dateStartAt),
    startTime: bidsListing?.childCapacity?.slotStartAt,
    endDate:
      bidsListing?.childCapacity?.dateEndAt &&
      new Date(bidsListing?.childCapacity?.dateEndAt),
    endTime:
      bidsListing?.childCapacity?.slotEndAt &&
      (bidsListing?.childCapacity?.slotEndAt === "23:59"
        ? "24:00"
        : bidsListing?.childCapacity?.slotEndAt),
    amount:
      role === "GENERATOR"
        ? bidsListing?.childCapacity?.sellingCost
        : bidsListing?.childCapacity?.landingCost,
    energyRateStr: bidsListing?.childCapacity?.energyRateStr,
    energy:
      role === "GENERATOR"
        ? bidsListing?.childCapacity?.sellEnergy
        : bidsListing?.childCapacity?.purchaseEnergy,
    energyType:
      role === "GENERATOR"
        ? generatorPlantDetails?.energyType?.type
          ? generatorPlantDetails.energyType.type
          : "NA"
        : bidsListing?.childCapacity?.energyType?.type
        ? bidsListing?.childCapacity?.energyType?.type
        : "NA",
    pointOfIngestion: generatorPlantDetails?.poi?.value
      ? generatorPlantDetails.poi.value
      : "",
    pointOfDrawl: consumerDetails?.pod?.value ? consumerDetails.pod.value : "",
    voltageLevel:
      role === "GENERATOR"
        ? generatorPlantDetails?.discomVoltage === null
          ? bidsListing?.childCapacity?.isStu
            ? generatorPlantDetails?.company?.stuVoltageLevel
            : generatorPlantDetails?.company?.istsVoltageLevel
          : generatorPlantDetails?.discomVoltage
        : consumerDetails?.discomVoltage === null
        ? bidsListing?.childCapacity?.isStu
          ? consumerDetails?.company?.stuVoltageLevel
          : consumerDetails?.company?.istsVoltageLevel
        : consumerDetails?.discomVoltage,
    expiryDate:
      (bidsListing?.childCapacity?.bidEndAt &&
        new Date(bidsListing?.childCapacity?.bidEndAt)) ||
      "",
    expiryTime:
      (bidsListing?.childCapacity?.bidEndAt &&
        moment(bidsListing?.childCapacity?.bidEndAt).format("HH:mm")) ||
      "",
  };

  useEffect(() => {
    if (role === "GENERATOR") {
      getGeneratorPlantDetails()(dispatch);
    } else if (role === "CONSUMER") {
      getConsumerDetails()(dispatch);
    }
  }, []);

  const validationSchema = Yup.object().shape({
    startDate: Yup.date().required("required field"),
    startTime: Yup.string().required("required field"),
    endDate: Yup.date().required("required field"),
    endTime: Yup.string().required("required field"),
    energy: Yup.number()
      .test(
        "valueRange",
        `Value must be between 0 and ${
          generatorPlantDetails?.installedCap || consumerDetails?.maxCapDrawl
            ? role === "GENERATOR"
              ? generatorPlantDetails.installedCap
              : consumerDetails?.maxCapDrawl
            : "10000"
        } with 3 decimal places`,
        (value) => {
          if (value === undefined || value === null) {
            return true;
          }
          const decimal = String(value).split(".")[1];
          return (
            value >= 0 &&
            value <=
              (generatorPlantDetails?.installedCap ||
              consumerDetails?.maxCapDrawl
                ? role === "GENERATOR"
                  ? generatorPlantDetails?.installedCap
                  : consumerDetails?.maxCapDrawl
                : 10000) &&
            (decimal?.length <= 3 || !decimal)
          );
        }
      )
      .required("Quantity is a required field"),
  });

  const numberInputOnWheelPreventChange = (e) => {
    // Prevent the input value change
    e.target.blur();

    // Prevent the page/container scrolling
    e.stopPropagation();

    // Refocus immediately, on the next tick (after the current function is done)
    setTimeout(() => {
      e.target.focus();
    }, 0);
  };

  return (
    <div className="container-fluid">
      <div className="">
        <div className="col-md-12">
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              disableButton()(dispatch);
              let startTime = values.startTime;
              let endTime = values.endTime;
              if (typeof startTime !== "string") {
                startTime = dayjs(startTime).format("HH:mm");
              }
              if (typeof endTime !== "string") {
                endTime = dayjs(endTime).format("HH:mm");
              }
              const requestBody = {
                id:
                  bidItem?.isEditable === true
                    ? bidsListing?.childCapacity?.id
                    : null,
                name: bidsListing?.childCapacity?.name,
                quantity: values.energy,
                amount: !fixedValue ? 0 : values.amount,
                energyRateStr: !fixedValue ? values.energyRateStr : "",
                generatorStatus: role === "GENERATOR" ? "PLACED" : "RECEIVED",
                consumerStatus: role === "CONSUMER" ? "PLACED" : "RECEIVED",
                [role === "GENERATOR"
                  ? "capacityConsumerId"
                  : "capacityGeneratorId"]: bidItem?.id,
                [role === "GENERATOR"
                  ? "capacityGeneratorId"
                  : "capacityConsumerId"]: selectedCardData?.id,
                dateStartAt: `${moment(values.startDate).format(
                  "DD-MMM-YYYY"
                )}`,
                dateEndAt: `${moment(values.endDate).format("DD-MMM-YYYY")}`,
                slotStartAt: startTime,
                slotEndAt: endTime && endTime === "24:00" ? "23:59" : endTime,
                otcRequest: bitType === "OTC",
              };
              role === "GENERATOR"
                ? biddingGeneratorService
                    .placeBidGenerator(requestBody)
                    .then((response) => {
                      if (response?.data?.code === 200) {
                        toast.success(
                          `${response?.data?.message}`,
                          toastProperties
                        );
                        getMatchingProfiles(selectedCardData?.id);
                        closeChildCapacityModal();
                        closeAddsBidsModal();
                        enableButton()(dispatch);
                        handlePlaceBidText(bidItem?.id);
                      } else if (response?.data?.code !== 200) {
                        enableButton()(dispatch);
                      }
                    })
                    .catch((error) => {
                      console.error("API call error", error);
                      enableButton()(dispatch);
                    })
                : biddingConsumerService
                    .placeBidConsumer(requestBody)
                    .then((response) => {
                      if (response?.data?.code === 200) {
                        toast.success(
                          `${response?.data?.message}`,
                          toastProperties
                        );
                        getMatchingProfilesCon(selectedCardData?.id);
                        closeChildCapacityModal();
                        closeAddsBidsModal();
                        enableButton()(dispatch);
                        handlePlaceBidText(bidItem?.id);
                      } else if (response?.data?.code !== 200) {
                        enableButton()(dispatch);
                      }
                    })
                    .catch((error) => {
                      console.error("API call error", error);
                      enableButton()(dispatch);
                    });
            }}
            validateOnMount={false}
            validate={(values) => {
              const errors = {};
              const currentDateTime = new Date();
              const maxStartTime = addHours(currentDateTime, 3);
              let selectedStartTime = values.startTime;
              const minExpiryTime = addHours(currentDateTime, 1);
              let selectedTExpiryTime = values.expiryTime;
              if (typeof selectedTExpiryTime === "string") {
                selectedTExpiryTime = dayjs(new Date())
                  .set("hour", parseInt(selectedTExpiryTime.split(":")[0]))
                  .set("minute", parseInt(selectedTExpiryTime.split(":")[1]));
              }
              if (typeof selectedStartTime === "string") {
                selectedStartTime = dayjs(new Date())
                  .set("hour", parseInt(selectedStartTime.split(":")[0]))
                  .set("minute", parseInt(selectedStartTime.split(":")[1]));
              }
              let startTimeValue = values.startTime;
              let endTimeValue = values.endTime;
              if (typeof startTimeValue === "string") {
                startTimeValue = dayjs(new Date())
                  .set("hour", parseInt(startTimeValue.split(":")[0]))
                  .set("minute", parseInt(startTimeValue.split(":")[1]));
              }
              if (typeof endTimeValue === "string") {
                endTimeValue = dayjs(new Date())
                  .set("hour", parseInt(endTimeValue.split(":")[0]))
                  .set("minute", parseInt(endTimeValue.split(":")[1]));
              }
              const minEndTime = startTimeValue.add(15, "minute");

              if (endTimeValue.isBefore(minEndTime)) {
                errors.endTime =
                  "End time must be at least 15 minutes after start time.";
              }

              const validateTime = (time, field) => {
                if (time) {
                  const timeSplit = time.split(":");
                  const minutesArr = ["00", "15", "30", "45"];
                  if (!minutesArr.includes(timeSplit[1])) {
                    errors[field] =
                      "Time should be in 15-minute intervals only";
                  }
                }
              };

              validateTime(values?.startTime, "startTime");
              validateTime(values?.endTime, "endTime");
              validateTime(values?.expiryTime, "expiryTime");

              if (
                values.startDate &&
                values.startDate.toDateString() ===
                  currentDateTime.toDateString() &&
                selectedStartTime.isBefore(maxStartTime)
              ) {
                errors.startTime =
                  "Start time must be at least 3 hours from the current time.";
              }
              return errors;
            }}
          >
            {({
              isSubmitting,
              setFieldTouched,
              setFieldValue,
              values,
              handleBlur,
              errors,
            }) => {
              let startTimeValue = values.startTime;
              let endTimeValue = values.endTime;
              if (typeof startTimeValue == "string") {
                startTimeValue = dayjs(new Date())
                  .set("hour", parseInt(startTimeValue.split(":")[0]))
                  .set("minute", parseInt(startTimeValue.split(":")[1]));
              }
              if (typeof endTimeValue == "string") {
                endTimeValue = dayjs(new Date())
                  .set("hour", parseInt(endTimeValue.split(":")[0]))
                  .set("minute", parseInt(endTimeValue.split(":")[1]));
              }
              // const startTimeValue1 =
              return (
                <Form>
                  <div className="row justify-contnet-center align-items-center ">
                    <div className="col-md-12">
                      <div className="">
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <div className="row">
                              <div className="col-md-6 mb-2 mb-md-0">
                                <label>Start Date</label>
                                <DatePicker
                                  className="custom-input w-100"
                                  name="startDate"
                                  selected={values.startDate}
                                  onChange={(date) =>
                                    setFieldValue("startDate", date)
                                  }
                                  minDate={
                                    new Date(selectedCardData?.dateStartAt)
                                  }
                                  maxDate={
                                    new Date(selectedCardData?.dateEndAt)
                                  }
                                  onBlur={handleBlur("startDate")}
                                  dateFormat="dd-MMM-yyyy"
                                  placeholderText="Date*"
                                  autoComplete="off"
                                  showMonthDropdown
                                  scrollableMonthYearDropdown
                                  showYearDropdown
                                />
                                <ErrorMessage
                                  name="startDate"
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                              <div className="col-md-6 mb-2 mb-md-0">
                                <label>End Date</label>
                                <DatePicker
                                  className="custom-input w-100"
                                  name="endDate"
                                  selected={values.endDate}
                                  onChange={(date) =>
                                    setFieldValue("endDate", date)
                                  }
                                  minDate={
                                    new Date(selectedCardData?.dateStartAt)
                                  }
                                  maxDate={
                                    new Date(selectedCardData?.dateEndAt)
                                  }
                                  onBlur={handleBlur("endDate")}
                                  dateFormat="dd-MMM-yyyy"
                                  placeholderText="Date*"
                                  autoComplete="off"
                                  showYearDropdown
                                  showMonthDropdown
                                  scrollableMonthYearDropdown
                                />
                                <ErrorMessage
                                  name="endDate"
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="row">
                              <div className="col-md-6 mb-2 mb-md-0 minutesStep">
                                <label>
                                  Start Time &nbsp;
                                  <OverlayTrigger
                                    placement="right"
                                    overlay={
                                      <Tooltip>
                                        Start time must be at least 3 hours from
                                        the current time.
                                      </Tooltip>
                                    }
                                  >
                                    <i
                                      className="bi bi-info-circle"
                                      style={{ color: "#4169e1" }}
                                    ></i>
                                  </OverlayTrigger>
                                </label>
                                <CustomTimePicker
                                  minutesStep={15}
                                  updateTimeToParent={(timeText) => {
                                    setFieldValue("startTime", timeText);
                                  }}
                                  time={values.startTime}
                                  maxHours={24}
                                  hasInititalValues={true}
                                />
                                <ErrorMessage
                                  name="startTime"
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                              <div className="col-md-6 mb-2 mb-md-0 minutes-step-15">
                                <label>End Time</label>
                                <CustomTimePicker
                                  minutesStep={15}
                                  updateTimeToParent={(timeText) => {
                                    setFieldValue("endTime", timeText);
                                  }}
                                  time={values.endTime}
                                  minTime={values.startTime}
                                  minTimeDiffInMinutes={15}
                                  maxHours={25}
                                  hasInititalValues={true}
                                />
                                <ErrorMessage
                                  name="endTime"
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <hr className="horizontal-line" />
                        <div className="row mt-3">
                          <div className="col-md-4 mb-2 mb-md-0 position-relative">
                            <label
                              htmlFor="energyType"
                              className="postion-label-dynamic"
                            >
                              <div
                                onClick={() => setFixedValue(!fixedValue)}
                                style={{ display: "flex" }}
                              >
                                <span style={{ marginRight: "8px" }}>
                                  Energy Rate (₹ per unit)
                                </span>
                                <label>Fixed Rate</label>
                                {fixedValue ? (
                                  <CheckBoxIcon
                                    style={{
                                      fontSize: "16px",
                                      color: "orange",
                                    }}
                                  />
                                ) : (
                                  <CheckBoxOutlineBlankIcon
                                    style={{
                                      fontSize: "16px",
                                    }}
                                  />
                                )}
                              </div>
                            </label>
                            {fixedValue ? (
                              <Field
                                type="number"
                                onWheel={numberInputOnWheelPreventChange}
                                className="custom-input no-spinner"
                                placeholder=""
                                name="amount"
                              />
                            ) : (
                              <Field
                                type="text"
                                onWheel={numberInputOnWheelPreventChange}
                                className="custom-input no-spinner"
                                placeholder=""
                                name="energyRateStr"
                              />
                            )}
                            <ErrorMessage
                              name="amount"
                              component="div"
                              className="text-danger"
                            />
                          </div>
                          <div className="col-md-4 mb-2 mb-md-0 position-relative">
                            <label
                              htmlFor="energyType"
                              className="postion-label-dynamic"
                            >
                              Quantity (MW)*
                            </label>
                            <Field
                              type="number"
                              onWheel={numberInputOnWheelPreventChange}
                              className="custom-input no-spinner"
                              placeholder=""
                              name="energy"
                              inputMode="numeric"
                            />
                            <ErrorMessage
                              name="energy"
                              component="div"
                              className="text-danger"
                            />
                          </div>
                          <div className="col-md-4 mb-2 mb-md-0 position-relative">
                            <label
                              htmlFor="energyType"
                              className="postion-label-dynamic"
                            >
                              Energy Type
                            </label>
                            <Field
                              type="text"
                              className="custom-input"
                              placeholder="Solar*"
                              name="energyType"
                              disabled
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          {role === "GENERATOR" && (
                            <div className="col-md-4 mb-2 mb-md-0 position-relative">
                              <label
                                htmlFor="pointOfIngestion"
                                className="postion-label-dynamic"
                              >
                                Point of Injection
                              </label>
                              <Field
                                type="text"
                                className="custom-input"
                                name="pointOfIngestion"
                                disabled
                              />
                            </div>
                          )}
                          {role === "CONSUMER" && (
                            <div className="col-md-4 mb-2 mb-md-0 position-relative">
                              <label
                                htmlFor="pointOfDrawl"
                                className="postion-label-dynamic"
                              >
                                Point of Drawl
                              </label>
                              <Field
                                type="text"
                                className="custom-input"
                                name="pointOfDrawl"
                                disabled
                              />
                            </div>
                          )}
                          <div className="col-md-4 mb-2 mb-md-0 position-relative">
                            <label
                              htmlFor="voltageLevel"
                              className="postion-label-dynamic"
                            >
                              Voltage Level (KV)
                            </label>
                            <Field
                              type="text"
                              className="custom-input"
                              name="voltageLevel"
                              disabled
                            />
                          </div>
                        </div>
                        <hr className="horizontal-line mt-3" />
                        <div className="">
                          <div className="button-alignment-class">
                            <div className="button-alignment-class-end">
                              <button
                                type="submit"
                                className="btn btn-signup btn btn-primary"
                                disabled={isButtonEnabled}
                              >
                                Connect
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};
